<div class="accidentes">
  <!-- Request -->
  <div class="card request">
    <form (ngSubmit)="onSubmitConsult()">
      <h5 class="title">Aviso de accidentes</h5>
      <div class="input-box reclamo">
        <div class="input-label-box">
          <label for="reclamo">Consultar un reclamo existente</label>
          <input
          type="text"
          name="reclamo"
          id="reclamo"
          class="input-field"
          placeholder=""
          [maxlength]="9"
          (input)="onlyNumbers($event)"
          (keypress)="onlyNumbers($event)"
          (paste)="onlyNumbers($event)"
          [(ngModel)]="eventNumber" />
        </div>
        <button [disabled]="eventNumber.length < 6" type="submit" class="btn-m-new consultar">Consultar</button>
      </div>
    </form>
  </div>


  <!-- Modal de consulta de reclamo -->
  @if ( claimConsultData && showModal && !isLoading) {
  <div class="claim-modal">
    <div class="modal-container">
      <div class="title">
        <h5>Reclamo No: {{ claimConsultData.eventNumber }}</h5>
        <span>Status: {{ claimConsultData.eventStatusDescription }}</span>
      </div>

      <accidentes-documentos-requeridos
        [alreadyUploadedDocuments]="claimConsultData.documents"
        [policyNumber]="claimConsultData.policyNumber"
        [lossType]="claimConsultData.lossType"
        [coverageCode]="claimConsultData.coverageCode"
        [eventNumber]="claimConsultData.eventNumber"
        (refreshInfo)="onSubmitConsult('completing files')"
        ></accidentes-documentos-requeridos>

      <ul class="modal-info-list">
        <!-- Info asegurado -->
        <li>
          <span>Nombre del asegurado:</span>
          {{ claimConsultData.clientInfo.claimantName }}
        </li>
        <li>
          <span>Núm. de identificación:</span>
          {{ document }}: {{ claimConsultData.clientInfo.idNumber }}
        </li>
        <li>
          <span>Núm. de póliza:</span> {{ claimConsultData.policyNumber }}
        </li>
        <li>
          <span>Correo:</span> {{ emailAddress }}
        </li>
        <li>
          <span>Celúlar:</span> {{ phoneNumber }}
        </li>
        <hr />
        <!-- Info Accidente -->
        <li>
          <span>Fecha del accidente:</span>
          {{ lossDate }}
        </li>
        <li>
          <span>Nombre del conductor:</span> {{ claimConsultData.driverName }}
        </li>
        <li>
          <span>Vehículo:</span> {{ vehicle!.makeModelDescription + "/" + vehicle!.registrationNumber + " /" +
          vehicle!.vinNumber }}
        </li>
        <li>
          <span>Tipo de siniestro:</span>
          {{ coverage?.shortDescription }}
        </li>
        <li>
          <span>Detalles de siniestro:</span>
          {{ claimConsultData.eventDescription }}
        </li>
        <hr />
        <li>
          <span>¿Hubo lesiones?:</span> {{ claimConsultData.hasInjured ? "Sí" : "No" }}
        </li>
        <li>
          <span>¿Vehículo inmóvil?:</span>
          {{ claimConsultData.stationaryVehicle ? "Sí" : "No" }}
        </li>
      </ul>
      <hr />
      <div class="button-container">
        <button (click)="downloadClaim()" class="btn-m-new pdf">Descargar</button>
        <button (click)="onShowModal()" class="btn-s-new cerrar">Cerrar</button>
      </div>
    </div>
  </div>
  }

  <!-- Notificacion -->

  <app-notification [show]="showNotification" [type]="notificationType" [title]="notificationTitle"
    [message]="notificationMessage"></app-notification>

</div>
